const editorModes = {
    BULK_EDIT: 'Bulk Edit',
    RICH_UI: 'Rich UI',
};

export default editorModes;
